import { render, staticRenderFns } from "./POSCart.vue?vue&type=template&id=5629bac8&scoped=true"
import script from "./POSCart.vue?vue&type=script&lang=js"
export * from "./POSCart.vue?vue&type=script&lang=js"
import style0 from "./POSCart.vue?vue&type=style&index=0&id=5629bac8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5629bac8",
  null
  
)

export default component.exports